import React from 'react';
import { useTranslation } from "react-i18next";
import Alert from "v4/components/admin/Alert/Alert";
import InlineLoader from "v4/components/ui/InlineLoader/InlineLoader";
import ToggleComponent from "v4/components/utils/ToggleComponent/ToggleComponent";
import { useFrontContext } from "v4/contexts/FrontContext";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";

/**
 * DynamicRouter (ou FrontRouter) orchestre le rendu des vues V4.
 * Il gère deux couches :
 * 1. Le Listing (Background) qui reste monté via ToggleComponent.
 * 2. Le Détail (Active) qui s'affiche par-dessus.
 */
export default function DynamicRouter() {
    const { t } = useTranslation();
    const { isLoading, currentRoute } = useNavigation();
    const { backgroundListing } = useFrontContext();
    const { route, routeConfig, isDetail, groupId } = currentRoute;

    if (isLoading) return <InlineLoader/>;

    if (!routeConfig) return (
        <div style={{ width: '100%' }}>
            <Alert
                type="warning"
                title={t('tab_item_not_found_msg')}
                message={t('configuration_not_found')}
            />
        </div>
    );

    // Calcul d'une clé stable pour les vues de détail (basée sur le groupe : code + id)
    const detailKey = isDetail ? `${routeConfig.component.name}-${routeConfig.groupCode}-${groupId || route.native_identifier}` : null;

    return (
        <div id="v4-dynamic-router" className="v4-dynamic-router" style={{ width: '100%' }}>
            {/* COUCHE 1 : Le Listing (Persistant) */}
            {backgroundListing && (
                <ToggleComponent isShowing={!isDetail}
                                 className="router-layer listing-layer"
                >
                    <backgroundListing.routeConfig.component
                        key={backgroundListing.route.url || backgroundListing.route.native_identifier}/>
                </ToggleComponent>
            )}

            {/* COUCHE 2 : Le Détail (Overlay) */}
            {isDetail && routeConfig?.component && (
                <ToggleComponent isShowing={isDetail}
                                 className="router-layer detail-layer"
                                 shouldRemoveFromDom
                >
                    <routeConfig.component key={detailKey || route.url || route.native_identifier}/>
                </ToggleComponent>
            )}

            {/* Cas d'erreur : aucune route ni listing parent */}
            {!routeConfig?.component && !backgroundListing && (
                <div className="error-container">Aucune vue à afficher</div>
            )}
        </div>
    );
}

